
const HandleHashInput = (event, index, hashRef) => {
    let offset = 0;

    if (event.type === 'input') {
        offset = event.target.value === '' ? -1 : 1;
    } else if (event.type === 'keyup' && event.code === 'Backspace' && event.target.value === '') {
        offset = -1;
    } else {
        return;
    }

    const targetIndex = index + offset;

    if (targetIndex >= 0 && targetIndex < hashRef.current.length) {
        const targetInput = hashRef.current[targetIndex];

        if (targetInput) {
            targetInput.focus();
            targetInput.select();
        }
    }
};

export default HandleHashInput;